import React from 'react'

import ControlledModal from '../../../components/modals/ControlledModal'
import EditTagForm from './EditTagForm'
import ModalHeader from './ModalHeader'
import PermissionChecker from '../../session/_shared/PermissionChecker'
import TagLoader from './_load/TagLoader'

const EditTagModal = () => {
  return (
    <PermissionChecker permission="setupServiceOrderTag">
      <ModalHeader />
      <TagLoader>
        <EditTagForm />
      </TagLoader>
    </PermissionChecker>
  )
}

const Wrapper = props => (
  <ControlledModal width="30rem" {...props}>
    <EditTagModal {...props} />
  </ControlledModal>
)

export default Wrapper
